import { FunctionComponent, useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { paletteHelper } from '@property.com.au/ui-kit';
import { ChatHeader } from '../ChatHeader/ChatHeader';
import { ChatWrapper } from '../ChatWrapper/ChatWrapper';
import { useChat } from './hooks/useChat';
import { Message } from './subcomponents/Message';
import { ChatForm } from './subcomponents/ChatForm';

const PcaChatWrapper = styled(ChatWrapper)`
  display: flex;
  flex-direction: column;
`;

const ChatBody = styled.div`
  position: relative;
  flex: 1;
  overflow-y: auto;
  display: flex;
  flex-direction: column;

  /* Make the scrollbar track transparent and adjust the thumb. */
  /* For Chrome, Safari, Opera (WebKit browsers) */
  &::-webkit-scrollbar {
    width: 6px; /* stylelint-disable-line plugin/no-unsupported-browser-features */
  }
  &::-webkit-scrollbar-track {
    background: transparent; /* stylelint-disable-line plugin/no-unsupported-browser-features */
  }
  &::-webkit-scrollbar-thumb {
    background-color: ${paletteHelper('borderSecondary')};
    border-radius: 4px;
  }

  /* For Firefox (the scrollbar and track colors). */
  scrollbar-width: thin; /* stylelint-disable-line plugin/no-unsupported-browser-features */
  scrollbar-color: ${paletteHelper('borderSecondary')} transparent; /* stylelint-disable-line plugin/no-unsupported-browser-features */
`;

export const PcaChat: FunctionComponent = () => {
  const { sessionId, messages, loading, handleSubmit, appendChat } = useChat();
  const userInteractionRef = useRef<HTMLDivElement>(null);
  const messagesEndRef = useRef<HTMLDivElement>(null);
  const [lastUserHeight, setLastUserHeight] = useState<number>(0);

  useEffect(() => {
    const el = userInteractionRef.current;
    if (el) {
      const h = el.clientHeight;
      setLastUserHeight(h);
    }
  }, [messages.length]);

  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages.length]);

  return (
    <PcaChatWrapper>
      <ChatHeader />
      <ChatBody>
        {messages.map((message, index) => (
          <Message
            key={message.invocationId}
            message={message}
            appendChat={appendChat}
            lastMessage={messages.length - 1 === index && index !== 0 && message.sender === 'agent'}
            offset={lastUserHeight}
            loading={loading}
            userInteractionRef={index === messages.length - 2 ? userInteractionRef : undefined}
          />
        ))}
        <div ref={messagesEndRef} />
      </ChatBody>
      <ChatForm loading={loading} onSubmit={handleSubmit} sessionId={sessionId} />
    </PcaChatWrapper>
  );
};
